module.exports = __webpack_public_path__ + "img/macbook.1251f27a.png";